export const VAULT_SERVICES = {
    CLOSE_PORTAL: "CLOSE_PORTAL",
    FRISCO: "FRISCO",
    LOGICO: "LOGICO",
    FLEXICO: "FLEXICO",
    TANC: "TANC",
    BOFFIN: "BOFFIN",
    FIRST_PASS: "FIRST_PASS",
    FIRST_PASS_RESPONSES: "FIRST_PASS_RESPONSES",
    FIRST_PASS_UI_UPLOADS: "FIRST_PASS_UI_UPLOADS",
    FEEDBACK: "FEEDBACK",
    ADMIN_PANEL: "ADMIN_PANEL",
    AI_APP: "AI_APP"
}